
import { Component, Vue } from 'vue-property-decorator'
import { Form as ElForm, Input } from 'element-ui'
import LangSelect from '@/components/LangSelect/index.vue'
import SocialSign from './components/SocialSignin.vue'
import {auth, sendEvent} from "@/firebase/config";
import {ElLoadingComponent} from "element-ui/types/loading";
import { login } from '@/data/api/users'
import {setLocale} from "@/globalFunctions";

@Component({
  name: 'Login',
  components: {
    LangSelect,
    SocialSign
  }
})
export default class extends Vue {
  private validateUsername = (rule: any, value: string, callback: (error?: Error) => void) => {
    callback();
    // TODO: Fix validation
    // if (!isValidUsername(value) && false) {
    //   callback(new Error('Please enter the correct user name'))
    // } else {
    //   callback()
    // }
  }

  private validatePassword = (rule: any, value: string, callback: (error?: Error) => void) => {
    if (!value || value.length < 6) {
      callback(new Error('The password can not be less than 6 digits'))
    } else {
      callback()
    }
  }

  private loginForm = {
    email: '',
    password: ''
  }

  private loginRules = {
    email: [{ validator: this.validateUsername, trigger: 'blur' }],
    password: [{ validator: this.validatePassword, trigger: 'blur' }]
  }

  private visible = false;
  private passwordType = 'password'
  private loading = false
  private loader: ElLoadingComponent;
  private errorMessage = "";
  private capsTooltip = false

  mounted() {
    if (auth.currentUser?.uid){
      if (this.$route.query.code){
        this.$router.push("/verify?code=" + this.$route.query.code);
      } else if (this.$route.query.redirect){
        this.$router.push(this.$route.query.redirect as string);
      } else {
        this.$router.push("/dashboard");
      }
    }

    if (this.loginForm.email === '') {
      if (this.$refs.email){
        (this.$refs.email as Input).focus()
      }
    } else if (this.loginForm.password === '') {
      if (this.$refs.password){
        (this.$refs.password as Input).focus()
      }
    }
  }

  created(){
    // Set preferred language
    setLocale(localStorage.getItem("localePreference") || navigator.language);

    // Save redirect
    if (typeof this.$route.query.redirect === "string"){
      sessionStorage.setItem("redirect", this.$route.query.redirect);
    }
    if (typeof this.$route.query.code === "string"){
      sessionStorage.setItem("verificationCode", this.$route.query.code);
    }

    if (sessionStorage.getItem("token")){
      this.loader = this.$loading({
        fullscreen: true,
        background: "#fff",
        lock: true
      });
    } else {
      setTimeout(() => {
        this.visible = true;
      }, 500);
    }

    setTimeout(() => {
      if (!auth.currentUser?.uid){
        this.visible = true;
        this.loader?.close();
      }
    }, 2500);
  }

  beforeDestroy(){
    // Stop loading
    this.loader?.close();
  }

  private checkCapslock(e: KeyboardEvent) {
    const { key } = e
    this.capsTooltip = (key !== null && key?.length === 1 && (key >= 'A' && key <= 'Z'))
  }

  private handleLogin() {
    (this.$refs.loginForm as ElForm).validate(async(valid: boolean) => {
      if (valid) {
        this.loading = true

        // Log in user
        await login(this.loginForm).catch((error) => {
          this.errorMessage = this.$t('authentication.login.errors.' + error.code.split("/")[1]).toString();
          this.loading = false;
        });

        // Analytics
        sendEvent("login", {
          user_id: auth.currentUser?.uid
        });

        // Just to simulate the time of the request
        setTimeout(() => {
          this.loading = false;
        }, 10 * 1000);
      } else {
        return false
      }
    })
  }
}
